import { runStaffReviewAction } from "@/lib/review-concurrency/run-staff-review-action";

export const runEnrollmentReviewAction = runStaffReviewAction;
